/** Prefix used for the `tag` of MessageCreated Web Notifications (triggered by `PusherStore`) */
export const WN_MESSAGE_CREATED_PREFIX = 'mc:';

/** Prefix used for the `tag` of Incoming Call Web Notifications (triggered by `PhoneStore`) */
export const WN_INCOMING_CALL_PREFIX = 'ic:';

export const WN_EVENT_PREFIX = 'ec:';
